






















































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import DashboardHeaderComponent from "@/components/pages/dashboard/DashboardHeaderComponent.vue";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import PagenationComponent from "@/components/common/parts/PagenationComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import {
  DashboardInfo,
  Status,
  DashboardStore,
  SelectedRegion,
  SelectedPrefecture,
  SelectedCompany,
  SelectedStoregroup,
  SelectedStore
} from "@/typescript/pages/dashboard/types";
import { getStoreListApi } from "../typescript/api_client/emesh_api/stores/store_list_api";
import { getStoreSensorsApi } from "@/typescript/api_client/emesh_api/stores/store_sensors_api";
import { getEquipmentsMeasurementApi } from "@/typescript/api_client/emesh_api/equipments/equipments_measurement_api";
import { getAlertData } from "@/typescript/lib/common/get_alert_data";
import { getStatusImg } from "@/typescript/pages/dashboard/functions";
import { StoreStatus } from "@/typescript/pages/dashboard/types";
import {
  GetStoreListResponse,
  Store,
  GetStoreSensorsResponse
} from "@/typescript/api_client/emesh_api/stores/types";
import { AlertData } from "../typescript/lib/common/types";
import { getRoutePath } from "@/router/routes";
export {
  DashboardInfo,
  Status,
  GetStoreListResponse,
  DashboardStore,
  Store,
  GetStoreSensorsResponse,
  AlertData,
  StoreStatus,
  SelectedRegion,
  SelectedPrefecture,
  SelectedCompany,
  SelectedStoregroup,
  SelectedStore
};

@Component({
  components: {
    HeaderComponent,
    DashboardHeaderComponent,
    TableComponent,
    TbodyComponent,
    TItemComponent,
    EllipsisComponent,
    PagenationComponent,
    FooterComponent
  }
})
export default class DashboardPage extends Vue {
  $refs!: {
    pagenation: PagenationComponent;
  };

  PAGE_COUNT: number = 20;
  currentPageNo: number = 1;
  dashboardInfo: DashboardInfo | {} = {};
  selectedRegion?: SelectedRegion;
  selectedPrefecture?: SelectedPrefecture;
  selectedCompany?: SelectedCompany;
  selectedStoregroup?: SelectedStoregroup;
  selectedStatus?: Status = { name: "全て", value: "all" };
  selectedStore?: SelectedStore;
  inputSearchValue: string = "";
  inputStoreNo: string = "";
  stores: Store[] = [];
  // API 取得時の初期表示用判別フラグ
  isInitialDisplay: boolean = false;

  async makeDashboardStores(respStores: Store[]) {
    return await Promise.all(
      respStores.map(async respStore => {
        const storeAlerts: string[] | any = await getStoreSensorsApi(
          respStore.store_id
        ).then(async (resp: GetStoreSensorsResponse) => {
          const alertIds = resp.sensors.filter(s => s.alert_id !== null);

          if (!alertIds.length) return [];

          return await Promise.all(
            alertIds.map(async s => {
              const equipmentStatus = await getEquipmentsMeasurementApi({
                equipment_id: s.equipment_id
              }).then(e => {
                return e.status;
              });
              return getAlertData(
                s.alert_id as string,
                equipmentStatus as 0 | 1 | 2
              );
            })
          );
        });

        return {
          storeId: respStore.store_id,
          storeName: respStore.store_name,
          storeStatus: respStore.store_status,
          alerts: storeAlerts
        };
      })
    );
  }

  async makeDashboardInfo(resp: GetStoreListResponse): Promise<DashboardInfo> {
    return {
      allCount: resp.all_count,
      alertCount: resp.alert_count,
      stores: (await this.makeDashboardStores(resp.stores)) as DashboardStore[]
    };
  }

  async getStoreList(pageNo: number, params: any = {}) {
    const requiredParams = {
      page_no: pageNo,
      page_count: this.PAGE_COUNT
    };

    if (this.selectedRegion) {
      params = { ...params, region_id: this.selectedRegion.region_id };
    }

    if (this.selectedPrefecture) {
      params = {
        ...params,
        prefecture_id: this.selectedPrefecture.prefecture_id
      };
    }

    if (this.selectedCompany) {
      params = {
        ...params,
        company_id: this.selectedCompany.company_id
      };
    }

    if (this.selectedStoregroup) {
      params = {
        ...params,
        storegroup_id: this.selectedStoregroup.storegroup_id
      };
    }

    // all の場合は store_status を指定しない
    if (this.selectedStatus && this.selectedStatus.value !== "all") {
      params = {
        ...params,
        store_status: this.selectedStatus.value
      };
    }

    // 店舗名検索 input に文字列が存在する場合は input を優先して検索条件に加える
    if (this.inputSearchValue || this.selectedStore) {
      params = {
        ...params,
        store_name: this.inputSearchValue
          ? this.inputSearchValue
          : this.selectedStore?.store_name
      };
    }

    if (this.inputStoreNo) {
      params = {
        ...params,
        store_no: this.inputStoreNo
      };
    }

    getStoreListApi({ ...requiredParams, ...params }).then(
      (resp: GetStoreListResponse) => {
        this.makeDashboardInfo(resp).then(resp => {
          this.dashboardInfo = resp;
          this.isInitialDisplay = false;
        });
      }
    );

    const storeListParams = {
      page_no: 1,
      // 店舗名に表示する上限数は50件とする
      page_count: 50
    };
    const storesResp = await getStoreListApi({ ...storeListParams, ...params });

    // エラーの場合は stores が含まれないので、stores を空にする
    if (!storesResp["stores"]) {
      this.stores = [];
      return;
    }
    this.stores = storesResp.stores;
  }

  created() {
    this.isInitialDisplay = true;
    this.getStoreList(1);
  }

  joinAlerts(alerts: AlertData[]): string {
    // 重複している警報メッセージを削除
    return alerts
      .filter((value, index, self) => {
        return (
          self.findIndex(value2 => {
            return value2.msg === value.msg;
          }) === index
        );
      })
      .map(a => `[ ${a.msg} ]`)
      .join(" ");
  }

  getStatusImg(status: StoreStatus): string {
    return getStatusImg(status);
  }

  moveNextPage(isMove: boolean) {
    if (!isMove) return;
    this.currentPageNo += 1;
    this.getStoreList(this.currentPageNo);
  }

  movePrevPage(isMove: boolean) {
    if (!isMove) return;
    this.currentPageNo -= 1;
    this.getStoreList(this.currentPageNo);
  }

  changeCurrentPageNo(num: number) {
    this.currentPageNo = num;
    this.getStoreList(this.currentPageNo);
  }

  getItemStartNum(): number {
    if (!this.$refs.pagenation) return 0;
    return this.$refs.pagenation.getItemStartNum();
  }

  getItemEndNum(): number {
    if (!this.$refs.pagenation) return 0;
    return this.$refs.pagenation.getItemEndNum();
  }

  setValue(key: string, value: any) {
    this[key] = value;
  }

  changeFilterItem(key: string, value: any) {
    this[key] = value;
    this.getStoreList(1);
  }

  searchStoreName(value: string) {
    this.inputSearchValue = value;
    this.getStoreList(1);
  }

  searchStoreNo(value: string) {
    this.inputStoreNo = value;
    this.getStoreList(1);
  }

  isResult(): boolean {
    const dInfo = this.dashboardInfo as DashboardInfo;
    // && を使えば一行で書けるが、コンソール上にて length 参照エラーが出るため、2 行で記述
    if (!Object.keys(dInfo).length) return true;
    if (dInfo.stores.length <= 0) return true;
    return false;
  }

  moveTempPage(store: DashboardStore) {
    this.$router.push(
      getRoutePath("TempManagementsImagePage", {
        store_id: store.storeId
      })
    );
  }
}
